import { createChallenge } from 'actions/challenge';
import CreateChallengeForm from 'components/Admin/CreateChallengeForm';
import UserContext from 'contexts/user';

import DefaultLayout from 'layouts/default';
import { useSnackbar } from 'notistack';
import { useContext } from 'react';
import { useHistory } from 'react-router';
import './index.css';
const AdminPage = () => {
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const onSubmit = (data: {
    name: string;
    description: string;
    metrics: string[];
    levels: [number, number];
    env: string;
  }) => {
    createChallenge(data)
      .then(() => {
        enqueueSnackbar(`Succesfully created challenge ${data.name}`);
        history.push('/challenges');
      })
      .catch((err) => {
        enqueueSnackbar(err.message);
      });
  };
  return (
    <DefaultLayout>
      <div className="AdminPage">
        <CreateChallengeForm onSubmit={onSubmit} />
      </div>
    </DefaultLayout>
  );
};

export default AdminPage;
